import { ApiClient } from '../../core/api/ApiClient';
import { API_BASE_URL } from '../../core/config/api';

class FcmService {
  constructor() {
    this.apiClient = new ApiClient(API_BASE_URL);
  }

  /**
   * VoIP 전화 발신 (v3)
   * POST /fcm/send-voip-call-v3
   * @param {number} userId - 수신자 사용자 ID
   * @param {string} callerName - 발신자 이름
   */
  async sendVoipCall(userId, callerName = '약국 전화') {
    const response = await this.apiClient.post('/fcm/send-voip-call-v3', {
      user_id: userId,
      caller_name: callerName,
      handle: 'pharmpay',
    });
    return response;
  }
}

let instance = null;
export const getFcmService = () => {
  if (!instance) instance = new FcmService();
  return instance;
};
